import "../../../scss/components/_reports.scss";
import {
  DatePicker,
  Button,
  TextField,
} from "@finpay-development/shared-components";
import ClearIcon from "@mui/icons-material/Clear";
import {Grid, MenuItem, Tooltip, Typography} from '@mui/material';
import { Form, Formik } from "formik";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";

import { Filters } from "../../../implementation-specialist/models/reportsFilters";
import {
  reportsType,
  addedReportsType,
} from "../../../shared/Mocks/reportsType";
import { RootState } from "../../../shared/state/root-reducer";
import { AppDispatch } from "../../../shared/state/store";
import { commonFields } from "../../../shared/validation/schemas";
import {
  clearReportInfo,
} from "../../state/users/admin-slice";
import { Utils } from "../../../shared/utils";
import { CustomFormikProps } from "../../../shared/model/formik-props";
import { ClientStatusCardViewModel } from "../../../shared/model/client-status-card";
import {
  selectedClientAndFacilities,
  selectedClientFacilitiesInfo,
} from "../../../implementation-specialist/models/reportsFilters";
import { setClientAndFacilityData } from "../../state/users/admin-slice";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import moment from 'moment'

interface ReportsFilterProps {
  handleFilterReportType: (reportsFilters: Filters) => void;
  handleDashboardChange?: (dashboardId: number) => void;
  handleClientIdChange?: (clientId: number | null) => void;
  handleDateChange?: (startDate: any, endDate: any) => void;
  clientId?: number;
  reportId?: number;
  dashboardList?: any[];
  clientList: any[];
}

function AdminReports(props: ReportsFilterProps) {
  const { handleDashboardChange, handleClientIdChange, handleDateChange, dashboardList, clientList, clientId, reportId} = props;
  const dispatch = useDispatch<AppDispatch>();
  const validationSchema = Yup.object({
    startDate: commonFields.OPTIONAL_DATE,
    endDate: commonFields.OPTIONAL_DATE,
  });
  
  const stateFields = {
    reportFilters: useSelector(
      (state: RootState) => state.adminContext.adminUserContext.reportFilters
    ),
    allowedClients: useSelector(
      (state: RootState) => state.userContext.userProfile.allowedClients
    ),
    allClientswithFacilities: useSelector(
      (state: RootState) =>
        state.implementationContext.implementationSpecialistClient
          .allClientsWithFacillities!
    ),
    reportV2: useSelector(
        (state: RootState) =>
            state.adminContext.adminUserContext.getv2Reports
    ),
  };

  const {
    reportFilters,
    allowedClients,
    allClientswithFacilities,
    reportV2
  } = stateFields;

  let selectedClientsAndFaclities = {
    clientFacilitiesInfo: [],
  } as selectedClientFacilitiesInfo;

  allClientswithFacilities.forEach((client: ClientStatusCardViewModel) => {
    const clientAndFacilities = {
      clientId: client.clientId,
      facilities: [],
      totalFacilities:
        client.clientFacilities && client.clientFacilities!.length,
      checked: false,
    } as selectedClientAndFacilities;
    selectedClientsAndFaclities.clientFacilitiesInfo.push(clientAndFacilities);
  });

  useEffect(() => {
    async function setData() {
      await dispatch(setClientAndFacilityData(allowedClients));
    }
    setData();

  }, []);

  let initialValues = {
    startDate: reportFilters.startDate,
    endDate: reportFilters.endDate,
    reportType: reportFilters.reportType,
    admissionDate: reportFilters.admissionDate,
    dischargeDate: reportFilters.dischargeDate,
    patientName: reportFilters.patientName,
    clientId: reportFilters.clientId,
    facilityId: reportFilters.facilityId,
    clientsAndFacilities: selectedClientsAndFaclities,
    includeFacilityTotals: reportFilters.includeFacilityTotals,
  };

  const handleClick = (formik: CustomFormikProps) => {
    // we need to pass the dates from here to the parent

    let start = formik.values.startDate
    let end = formik.values.endDate

    if(!moment.isMoment(start)){
      start = !start ? "" : moment(start)
    }
    if(!moment.isMoment(end)){
      end = !end ? "" : moment(end)
    }
    handleDateChange!(start, end)
  };

  function handleResetFilters(formik: CustomFormikProps) {
    handleDateChange!('', '')
    dispatch(clearReportInfo());
    formik.resetForm();
  }

  const dateLabel = (reportType: string) => {
    switch (reportType) {
      case addedReportsType[3]:
        return "Settlement Date";
      case reportsType[0]:
        return "Convert Date";
      default:
        return "Date";
    }
  }

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const formatedId = Number(e.target.value)
    handleDashboardChange!(formatedId);
  };

  const handleIdSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    handleClientIdChange!(Number(e.target.value));
  };

  return (
    <div>
      <Typography variant="subtitle2" className="mb-8">
        Filters
      </Typography>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={() => {}}
        validate={() => {}}
        enableReinitialize
      >
        {(formik) => {
          return (
          <Form data-testid="filter-form" noValidate>
            <Grid container spacing={3}>
            <Grid xs={12} container item style={{marginBottom: "18px", display: "flex", flexWrap: "nowrap"}}>
              <Grid item xs={12}>
                <TextField
                    select={true}
                    error=""
                    name="reportType"
                    label="Report"
                    value={reportId}
                    onChange={handleSelectChange}
                    helperText="Please select a Report"
                    onBlur={formik.handleBlur}
                    test-id={`report-drop-down-menu`}
                >
                  {dashboardList!.map((option) => (
                      <MenuItem key={option.reportId} value={option.reportId}>
                        {option.title}
                      </MenuItem>
                  ))}
                </TextField>
              </Grid>
              {
                reportV2.description && (
                      <Grid item xs={1} sx={{mt: 2, ml: 1}}>
                        <Tooltip title={reportV2.description} placement="right">
                          <HelpOutlineIcon/>
                        </Tooltip>
                      </Grid>
                  )
              }
              </Grid>

            <Grid xs={12} item>
              <TextField
                  select={true}
                  error=""
                  name="reportType"
                  label="Client"
                  value={clientId}
                  onChange={handleIdSelectChange}
                  onBlur={formik.handleBlur}
                  className="state-field"
                  test-id={`report-client-drop-down-menu`}
                >
                  {clientList!.map((option) => (
                      <MenuItem key={option.clientId} value={option.clientId}>
                          {option.label}
                      </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid xs={6} item>
                <DatePicker
                  error={
                    Utils.isValidDate(formik.values.startDate) &&
                    formik.touched["startDate"] &&
                    formik.errors["startDate"]
                  }
                  label={`Start ${dateLabel(formik.values.reportType)}`}
                  value={formik.values.startDate ? new Date(formik.values.startDate) : formik.values.startDate}
                  onChange={(date: Date) => {
                    formik.setFieldValue("startDate", date)
                    // handleDateChange!(date, formik.values.endDate)
                  }}
                  minDate={Utils.getMinDate()}
                  maxDate={Utils.getMaxDate()}
                  className="date-picker-fp"
                  test-id='report-start-date'
                />
              </Grid>
              <Grid xs={6} item >
                <DatePicker
                  error={
                    Utils.isValidDate(formik.values.endDate) &&
                    formik.touched["endDate"] &&
                    formik.errors["endDate"]
                  }
                  label={`End ${dateLabel(formik.values.reportType)}`}
                  value={formik.values.endDate ? new Date(formik.values.endDate) : formik.values.endDate}
                  onChange={(date: Date) => {
                    formik.setFieldValue("endDate", date);
                    // handleDateChange!(formik.values.startDate, date)
                  }}
                  minDate={Utils.getMinDate()}
                  maxDate={Utils.getMaxDate()}
                  className="date-picker-fp"
                />

              </Grid>
              <Grid container item xs={12} justifyContent='space-around'>
                <Grid item container xs={6}>
                  <Button
                      type="text"
                      icon={<ClearIcon />}
                      onClick={() => handleResetFilters(formik)}
                      style={{width: '100%'}}
                  >
                    Reset
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                      onClick={() => handleClick(formik)}
                      style={{width: '100%'}}
                      test-id='report-btn'
                  >
                    Run Report
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Form>
        )}}
      </Formik>
    </div>
  );
}

export default AdminReports;
